module.exports = __webpack_public_path__ + "img/dto-home71.53d36f78.png";